/**
 * Application configuration. The constants here will be replaced with the values from your build profile by
 * WebPack.
 * @type {object}
 */
const APP_CONFIG = {
  /**
   * Version of the frontend in use
   * @type {string}
   */
  version: VERSION,

  /**
   * Should debug messages be turned on?
   * @type {boolean}
   */
  debug: PROFILE_DEBUG,

  /**
   * Backend URL with path
   * @type {string}
   */
  be: PROFILE_BACKEND,

  /**
   * URL path to translation JSON files
   * @type {string}
   */
  translation_path: PROFILE_TRANSLATION_PATH || '/app/themes/oral.fi-theme2/embedded-app/i18n',

  ga: PROFILE_GA,

  gtm: PROFILE_GTM,

  facebook: PROFILE_FACEBOOK,

  gaExperiment: PROFILE_GA_EXPERIMENT,

  gaMaps: PROFILE_GA_MAPS,

  /**
   * Price used for all services if this value is set. If not set in active profile default value is set to undefined.
   * If set to undefined then normal price calculation is active.
   * For some reason webpack compilation fails without || undefined
   * During runtime correct value is anyways used from active profile
   * TODO  check this after webpack has been udpated if it will work with this hack
   * @type (number)
   */
  commonServicePrice: PROFILE_COMMON_SERVICE_PRICE ? PROFILE_COMMON_SERVICE_PRICE : undefined,
};

/**
 * Path to media files.
 * @type {string}
 */
APP_CONFIG.media = `${APP_CONFIG.be}/media/`;

export default APP_CONFIG;
